export const fuelTypes = [
    { code: 'SEM COMBUSTÍVEL' },
    { code: 'GASOLINA' },
    { code: 'ETANOL' },
    { code: 'DIESEL' },
    { code: 'FLEX POWER' },
    { code: 'GÁS NATURAL' }
]